import { render, staticRenderFns, recyclableRender, components } from "./login.vue?vue&type=template&id=12ddaf6e&scoped=true&"
var renderjs
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=12ddaf6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ddaf6e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "n_pages/login/login.vue"
export default component.exports